<template>
  <div v-if="deviceDid">
    <el-tabs v-model="active">
      <el-tab-pane  label="LAN" name="lan" :lazy="true">
        <lan
          ref="lan"
          v-if="active === 'lan'"
          :deviceDid="deviceDid"
          :deviceSoftwareVer="deviceSoftwareVer"
          :deviceSn="deviceSn">
        </lan>
      </el-tab-pane>
      <el-tab-pane label="WAN" name="wan" :lazy="true">
        <wan
          ref="wan"
          v-if="active === 'wan'"
          :deviceDid="deviceDid"
          :deviceSn="deviceSn">
        </wan>
      </el-tab-pane>
      <el-tab-pane label="MGT" name="mgt" :lazy="true">
        <mgt
          ref="mgt"
          v-if="active === 'mgt'"
          :deviceDid="deviceDid"
          :deviceSn="deviceSn">
        </mgt>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import lan from './components/lan/index'
import wan from './components/wan/index'
import mgt from './components/mgt/index'
export default {
  props: ["deviceDid", "deviceSn","deviceSoftwareVer"],
  components: {
    lan,
    wan,
    mgt
  },
  data() {
    return {
      active: 'lan'
    }
  },
  watch: {
    deviceSn: {
      immediate: true,
      handler(newValue, oldValue) {
        this.active = 'lan'
      },
    }
  },
}
</script>